import {
  FETCH_LIBERTY_REVIEW,
  FETCH_LIBERTY_REVIEW_SUCCESS,
  FETCH_LIBERTY_REVIEW_FAILURE,
  RECORD_LIBERTY_DECISION,
  RECORD_LIBERTY_DECISION_SUCCESS,
  RECORD_LIBERTY_DECISION_FAILURE,
} from "./constants";

/** @param {{ locationId: number|string }} payload */
export const fetchLibertyReview = (payload) => ({
  type: FETCH_LIBERTY_REVIEW,
  payload,
});
export const fetchLibertyReviewSuccess = (payload) => ({
  type: FETCH_LIBERTY_REVIEW_SUCCESS,
  payload,
});
export const fetchLibertyReviewFailure = () => ({
  type: FETCH_LIBERTY_REVIEW_FAILURE,
});

/**
 * Record the outcome of an AGNI review against one authorisation.
 *
 * @param {{ authorisationUuid: string, action: "keep"|"lapse"|"cease"|"defer_la", note?: string }} payload
 * @param {Function} [onSuccess] called with the server's `{ liberty_status, agni_review }`
 */
export const recordLibertyDecision = (payload, onSuccess) => ({
  type: RECORD_LIBERTY_DECISION,
  payload,
  onSuccess,
});
export const recordLibertyDecisionSuccess = (payload) => ({
  type: RECORD_LIBERTY_DECISION_SUCCESS,
  payload,
});
export const recordLibertyDecisionFailure = (payload) => ({
  type: RECORD_LIBERTY_DECISION_FAILURE,
  payload,
});
